import React, { useState, useEffect } from "react";
//import { trackPromise } from "react-promise-tracker";
import { useTranslation } from "react-i18next";

import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Box from "@material-ui/core/Box";

// API
import fetchServicesAsync from "./api/fetchServicesAsync";

const useStyles = makeStyles((theme) => ({
  spinnerProgress: {
    position: "absolute",
    top: "50%",
    left: "90%",
    marginTop: -5,
    marginLeft: -5,
  },
}));

export default function ServicePage({ fields, servicesWithDisclaimer, errors, handleChange }) {
  const classes = useStyles();
  const [loadingServices, setLoadingServices] = React.useState(false);

  const [services, setServices] = useState([]);
  const { t, i18n } = useTranslation();

  // componentDidMount
  useEffect(() => {
    fetchServices();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchServices = () => {
    if (!loadingServices) {
      setLoadingServices(true);

      fetchServicesAsync().then((services) => {
        setServices(services);
        setLoadingServices(false);
      });
    }
  };

  const handleServiceChange = (e) => {
    // get object and store it in state
    const service = services.find((service) => service.ServiceId === e.target.value);

    handleChange("service")(service);
  };

  return (
    <div>
      <Typography variant="h6" gutterBottom>
        {t("Choose your required service")}:
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <FormControl fullWidth error={!!errors["service"]}>
            <InputLabel id="service-select-label">{t("Service")}</InputLabel>
            <Select
              labelId="service-select-label"
              label={t("Service")}
              id="service-select"
              value={fields.service ? fields.service.ServiceId : ""}
              onChange={handleServiceChange}
            >
              {services &&
                services.map((service) => {
                  const serviceName = i18n.language === "ar" ? service.ServiceName_Ar : service.ServiceName_En;
                  const serviceType = t(service.Service_Type);

                  // multiple condition
                  const serviceCost =
                    service.Service_Fee === "0" ? t("Free") : i18n.language === "ar" ? service.Service_Fee + " ريال" : "SR. " + service.Service_Fee;

                  return (
                    <MenuItem key={service.ServiceId} value={service.ServiceId}>
                      {serviceName} ({serviceType}) {serviceCost}
                    </MenuItem>
                  );
                })}
            </Select>
            {loadingServices && <CircularProgress size={24} className={classes.spinnerProgress} />}
            <FormHelperText>{errors["service"]}</FormHelperText>
          </FormControl>

          {fields.service !== "" ? (
            <Box mt={1}>
              <Typography>{i18n.language === "ar" ? fields.service.Service_Desc_Ar : fields.service.Service_Desc_En}</Typography>
            </Box>
          ) : (
            ""
          )}

          {/* Disclaimer displayed only for services requiring it */}
          {servicesWithDisclaimer.includes(fields.service.ServiceId) ? (
            <Box mt={3}>
              <Typography>
                <b>{t("Disclaimer")}</b>
              </Typography>
              <FormControl required error={!!errors["measurementDisclaimer"]} component="fieldset">
                <FormControlLabel
                  onChange={handleChange("measurementDisclaimer")}
                  checked={fields.measurementDisclaimer}
                  control={<Checkbox color="primary" />}
                  label={
                    <div>
                      <p>{t("Kitchen measurement is required to be completed by IKEA team before Kitchen planning can be conducted.")}</p>
                      <p>{t("The kitchen planning appointment is appliable for one kitchen plan only.")}</p>
                    </div>
                  }
                  labelPlacement="end"
                />
                {!!errors["measurementDisclaimer"] ? <FormHelperText>{errors["measurementDisclaimer"]}</FormHelperText> : ""}
              </FormControl>
            </Box>
          ) : (
            ""
          )}
        </Grid>
      </Grid>
    </div>
  );
}
